import { ShigoDeploymentTarget } from './deployment';
import { dashboardT } from './messages';

export interface ShigoDocumentMetadata {
  displayName: string;
  faviconUrl: string;
  target: ShigoDeploymentTarget;
}

export function applyShigoDocumentMetadata(
  metadata: ShigoDocumentMetadata,
  targetDocument: Document = document,
) {
  targetDocument.title =
    metadata.target === ShigoDeploymentTarget.Development
      ? dashboardT('app.documentTitle.development', { name: metadata.displayName })
      : metadata.displayName;
  const favicon = targetDocument.querySelector<HTMLLinkElement>('#appFavicon');
  if (!favicon) return;

  if (metadata.faviconUrl) favicon.setAttribute('href', metadata.faviconUrl);
  else favicon.removeAttribute('href');
}
